import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    closeMobileMenu();

    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={() => { closeMobileMenu(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h1>SaveMove Umzüge</h1>
          <span className="tagline">Ihr vertrauensvoller Partner für Umzüge</span>
        </Link>

        <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            <li>
              <Link 
                to="/" 
                className="nav-link" 
                onClick={() => { closeMobileMenu(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              >
                Startseite
              </Link>
            </li>
            <li>
              <button 
                type="button" 
                className="nav-link" 
                style={{ background: 'none', border: 'none', cursor: 'pointer', font: 'inherit', padding: 0 }} 
                onClick={() => scrollToSection('services')}
              >
                Leistungen
              </button>
            </li>
            <li>
              <button 
                type="button" 
                className="nav-link" 
                style={{ background: 'none', border: 'none', cursor: 'pointer', font: 'inherit', padding: 0 }} 
                onClick={() => scrollToSection('about')}
              >
                Über uns
              </button>
            </li>
            <li>
              <button 
                type="button" 
                className="nav-link" 
                style={{ background: 'none', border: 'none', cursor: 'pointer', font: 'inherit', padding: 0 }} 
                onClick={() => scrollToSection('contact')}
              >
                Kontakt
              </button>
            </li>
          </ul>
        </nav>

        <div className="header-contact">
          <a href="tel:+4917684572071" className="phone-link">
            📞 +49 176 845 720 71
          </a>
        </div>

        <button 
          type="button" 
          className="mobile-menu-btn" 
          onClick={toggleMobileMenu}
          aria-label="Menü öffnen"
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}></span>
        </button>
      </div>
    </header>
  );
};

export default Header;